import ContactForm from "../components/ContactUs/ContactForm";
import ContactInfo from "../components/ContactUs/ContactInfo";
import HeroSection from "../components/HeroSection";
import NewsletterSubscription from "../components/NewsletterSubscription";

import ProjectList from "../components/Projects/ProjectList";

import projectHeroImage from "../assets/Setting_up_Innovation_Chain_EU_Darkhan_Mongolia_Innovation_Ecosystems_4.jpg";

const Projects = () => {

    return (
        <div>

            <HeroSection
                image={projectHeroImage}
                title={<span>Our <span style={{color:'yellow'}}>Projects</span> Are</span>}
                description={
                    <span style={{color:'white'}}>
                       Driving sustainable impact through climate innovation, digital transformation, and resilient development solutions.
                    </span>}
            />

            <div style={{display:'flex',justifyContent:'center',backgroundColor:'#f4f4f4'}}>

                <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>

                    <div style={{display:'flex',maxWidth:'900px',flexDirection:'column',alignItems:'center',padding:'20px 0',backgroundColor:'#f4f4f4'}}>
                        <h2 style={{color:'#1a3055',fontSize:'24px',fontWeight:'bold',textAlign:'center'}}>THEMES AND PROJECTS</h2>
                        <p style={{color:'#666',margin:0,textAlign:'center'}}>
                            At GreenWorks Consulting, we are committed to driving sustainable impact through innovative solutions. Our projects span various themes, including climate change mitigation, digital transformation, and resilient development. Explore our diverse portfolio of projects that exemplify our dedication to creating a greener, more sustainable future.
                        </p>
                    </div>

                    <div style={{padding:"40px"}}>
                        <ProjectList />
                    </div>

                </div>

            </div>
            
            <div style={{padding:'40px'}}>
                <div style={{display:'flex',gap:'30px',marginTop:'50px',flexWrap:'wrap'}}>
                    <ContactInfo />
                    <ContactForm />
                </div>
            </div>
            <div style={{padding:'20px'}}>
                <NewsletterSubscription />
            </div>
        </div>
    );
}

export default Projects;